module.exports = __webpack_public_path__ + "static/img/prize1.5540ffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/dragon/img/prize1.png
// module id = Bi4U
// module chunks = 1